const values = [2, 3, 4, 5, 6, 8, 16];
export default values.map(v => `mdl-shadow--${v}dp`);



/** WEBPACK FOOTER **
 ** ./src/utils/shadows.js
 **/